var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wh-100"},[_c('NavigationBar'),_c('v-main',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('a',{staticClass:"helpIcon",attrs:{"href":"https://wa.me/60127790406","target":"_blank"}},[_c('img',{attrs:{"src":"/assets/image/home/help.png","alt":""}})])],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }